import type { BaseInputType, InputType } from '@src/orders/FormEntries';
import type { TrailerInformationFormEntries } from '@src/orders/PermitFormSections/haulingEquipment/TrailerInformationSection';
import {
  AxleFormName,
  AxleWeightField,
} from '@src/permitField/AxleInformationFields';

export const calculateSumOfAxleWeights = (
  trailerFormValues: InputType | undefined,
  tractorAxlesFormValues: InputType | undefined,
): number => {
  const sumOfTrailerAxlesWeight: number = trailerFormValues
    ? (trailerFormValues as TrailerInformationFormEntries[]).reduce(
        (acc, trailerInformation) => {
          const trailerAxles = trailerInformation[AxleFormName];
          if (Array.isArray(trailerAxles)) {
            const trailerAxlesWeight: number = trailerAxles.reduce(
              (accAxle: number, currentAxle) => {
                const weight: number =
                  currentAxle[AxleWeightField.fieldName as keyof BaseInputType];
                if (weight !== undefined) {
                  return accAxle + weight;
                }
                return accAxle;
              },
              0,
            );
            return acc + trailerAxlesWeight;
          }
          return acc;
        },
        0,
      )
    : 0;

  let tractorAxlesWeight: number = 0;
  if (Array.isArray(tractorAxlesFormValues)) {
    tractorAxlesWeight = tractorAxlesFormValues.reduce(
      (accAxle: number, currentAxle) => {
        //@ts-ignore
        const weight: number = currentAxle[AxleWeightField.fieldName];
        if (weight !== undefined) {
          return accAxle + weight;
        }
        return accAxle;
      },
      0,
    );
  }

  return tractorAxlesWeight + sumOfTrailerAxlesWeight;
};
